import VueRouter from 'vue-router'

import tankAbandonment from '../components/TankAbandonment/TankAbandonment'
import tankAbandonmentThankYou from '../components/TankAbandonment/ThankYou'

import energySystems from '../components/EnergySystems/EnergySystems'
import energySystemsThankYou from '../components/EnergySystems/ThankYou'

import tankRefurbishment from '../components/TankRefurbishment/TankRefurbishment'
import tankRefurbishmentThankYou from '../components/TankRefurbishment/ThankYou'

import manyUnloadingForFuel from '../components/ManyUnloadingForFuel/ManyUnloadingForFuel'
import manyUnloadingForFuelThankYouDiesel from '../components/ManyUnloadingForFuel/ThankYouDiesel'
import manyUnloadingForFuelThankYouHeizoel from '../components/ManyUnloadingForFuel/ThankYouHeizoel'

import manyUnloadingForPellets from '../components/ManyUnloadingForPellets/ManyUnloadingForPellets'
import manyUnloadingForPelletsThankYou from '../components/ManyUnloadingForPellets/ThankYou'

import manyUnloadingForServices from '../components/ManyUnloadingForServices/ManyUnloadingForServices'
import manyUnloadingForServicesThankYouBoiler from '../components/ManyUnloadingForServices/ThankYouBoiler'
import manyUnloadingForServicesThankYouTank from '../components/ManyUnloadingForServices/ThankYouTank'

import contact from '../components/Contact/Contact'
import contactThankYou from '../components/Contact/ThankYou'

import newsletterSubscription from '../components/NewsletterSubscription/NewsletterSubscription'
import newsletterSubscriptionThankYou from '../components/NewsletterSubscription/ThankYou'

import newsletterUnsubscription from '../components/NewsletterUnsubscription/NewsletterUnsubscription'
import newsletterUnsubscriptionThankYou from '../components/NewsletterUnsubscription/ThankYou'

import competitionParticipation from '../components/CompetitionParticipation/CompetitionParticipation'
import competitionParticipationThankYou from '../components/CompetitionParticipation/ThankYou'

import genericInteraktionsformular from '../components/GenericInteraktionsformular/GenericInteraktionsformular'
import genericInteraktionsformularThankYou from '../components/GenericInteraktionsformular/ThankYou'

import eMobilityServices from '../components/EMobilityServices/EMobilityServices'
import eMobilityServicesThankYou from '../components/EMobilityServices/ThankYou'

import energyForum from '../components/EnergyForum/EnergyForum'
import energyForumThankYou from '../components/EnergyForum/ThankYou'

import lastTankBoilerCheck from '../components/LastTankBoilerCheck/LastTankBoilerCheck'
import lastTankBoilerCheckThankYou from '../components/LastTankBoilerCheck/ThankYou'

import sweepstake from '../components/Sweepstake/Sweepstake'
import sweepstakeThankYou from '../components/Sweepstake/ThankYou'

import eMobilityServicesSmall from '../components/EMobilityServicesSmall/EMobilityServicesSmall'
import eMobilityServicesSmallThankYou from '../components/EMobilityServicesSmall/ThankYou'

import migrolcardCompanyCard from '../components/MigrolcardCompanyCard/MigrolcardCompanyCard'
import migrolcardCompanyCardThankYou from '../components/MigrolcardCompanyCard/ThankYou'

export default function createRouter(serverSideSettings) {

    var routes = [];

    switch (serverSideSettings.FormType) {
        case 'TankAbandonment':
            routes.push({
                path: '/',
                component: tankAbandonment
            });
            routes.push({
                path: '/thanks',
                component: tankAbandonmentThankYou
            });
            break;
        case 'EnergySystems':
            routes.push({
                path: '/',
                component: energySystems
            });
            routes.push({
                path: '/thanks',
                component: energySystemsThankYou
            });
            break;
        case 'TankRefurbishment':
            routes.push({
                path: '/',
                component: tankRefurbishment
            });
            routes.push({
                path: '/thanks',
                component: tankRefurbishmentThankYou
            });
            break;
        case 'ManyUnloadingForFuel':
            routes.push({
                path: '/',
                component: manyUnloadingForFuel
            });
            routes.push({
                path: '/thanks-diesel',
                component: manyUnloadingForFuelThankYouDiesel
            });
            routes.push({
                path: '/thanks-oil',
                component: manyUnloadingForFuelThankYouHeizoel
            });
            break;
        case 'ManyUnloadingForPellets':
            routes.push({
                path: '/',
                component: manyUnloadingForPellets
            });
            routes.push({
                path: '/thanks',
                component: manyUnloadingForPelletsThankYou
            });
            break;
        case 'ManyUnloadingForServices':
            routes.push({
                path: '/',
                component: manyUnloadingForServices
            });
            routes.push({
                path: '/thanks-tank',
                component: manyUnloadingForServicesThankYouTank
            });
            routes.push({
                path: '/thanks-boiler',
                component: manyUnloadingForServicesThankYouBoiler
            });
            break;
        case 'Contact':
            routes.push({
                path: '/',
                component: contact
            });
            routes.push({
                path: '/thanks',
                component: contactThankYou
            });
            break;
        case 'NewsletterSubscription':
            routes.push({
                path: '/',
                component: newsletterSubscription
            });
            routes.push({
                path: '/confirm',
                component: newsletterSubscriptionThankYou
            });
            break;
        case 'NewsletterUnsubscription':
            routes.push({
                path: '/',
                component: newsletterUnsubscription
            });
            routes.push({
                path: '/confirm',
                component: newsletterUnsubscriptionThankYou
            });
            break;
        case 'CompetitionParticipation':
            routes.push({
                path: '/',
                component: competitionParticipation
            });
            routes.push({
                path: '/thanks',
                component: competitionParticipationThankYou
            });
            break;
        case 'GenericInteraktionsformular':
            routes.push({
                path: '/',
                component: genericInteraktionsformular
            });
            routes.push({
                path: '/thanks',
                component: genericInteraktionsformularThankYou
            });
            break;
        case 'EMobilityServices':
            routes.push({
                path: '/',
                component: eMobilityServices
            });
            routes.push({
                path: '/thanks',
                component: eMobilityServicesThankYou
            });
            break;
        case 'EMobilityServicesSmall':
            routes.push({
                path: '/',
                component: eMobilityServicesSmall
            });
            routes.push({
                path: '/thanks',
                component: eMobilityServicesSmallThankYou
            });
            break;
        case 'EnergyForum':
            routes.push({
                path: '/',
                component: energyForum
            });
            routes.push({
                path: '/thanks',
                component: energyForumThankYou
            });
            break;
        case 'LastTankBoilerCheck':
            routes.push({
                path: '/',
                component: lastTankBoilerCheck
            });
            routes.push({
                path: '/thanks',
                component: lastTankBoilerCheckThankYou
            });
            break;
        case 'Sweepstake':
            routes.push({
                path: '/',
                component: sweepstake
            });
            routes.push({
                path: '/thanks',
                component: sweepstakeThankYou
            });
            break;
        case 'MigrolcardCompanyCard':
            routes.push({
                path: '/',
                component: migrolcardCompanyCard
            });
            routes.push({
                path: '/thanks',
                component: migrolcardCompanyCardThankYou
            });
            break;            
    }

    return new VueRouter({
        mode: 'hash',
        fallback: false, //no backwards compatibility for old browsers
        routes: routes,
        scrollBehavior(to, from, savedPosition) {
            if (savedPosition) {
                return savedPosition
            } else {
                return { x: 0, y: 0 }
            }
        }
    });
}